import { ON_TRANSLATION_CHANGE } from "./types";

export const changeDisplayedLanguage = (newLang) => {
    return {
        type: ON_TRANSLATION_CHANGE,
        payload: newLang
    };
};